import React from "react";
import Reveal from "../../Reveal";
import { useI18n } from "../../../i18n/LanguageContext";
import { SITE } from "../../../content/site";

export default function EventsManifesto() {
  const { lang } = useI18n();
  const c = (SITE[lang].homeStory || SITE.en.homeStory).manifesto;
  return (
    <section data-testid="home-manifesto" className="relative z-10 -mt-[13vh] px-6 pb-28 pt-4 md:-mt-[17vh] md:px-12 md:pb-44 md:pt-8">
      <div className="mx-auto grid max-w-[1400px] gap-14 lg:grid-cols-12">
        <div className="lg:col-span-8">
          <Reveal><p className="overline text-[#0e7c6b]">{c.overline}</p></Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display mt-8 text-4xl font-light leading-[1.02] tracking-tightest text-[#050505] sm:text-5xl lg:text-7xl">
              {c.line1}
            </h2>
          </Reveal>
          <Reveal delay={0.25}>
            <h2 className="font-display mt-2 text-4xl font-light leading-[1.02] tracking-tightest text-[#b9b6af] sm:text-5xl lg:text-7xl">
              {c.line2}
            </h2>
          </Reveal>
        </div>
        <div className="flex items-end lg:col-span-4">
          <Reveal delay={0.35}>
            <p className="max-w-md text-base font-light leading-relaxed text-[#4a4a4a] md:text-lg">{c.text}</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
